import React from 'react';
import TemplateList from './TemplateList';

const TemplateTabContent = ({ 
  templates, 
  loading, 
  onEdit, 
  onDelete, 
  onUse,
  pagination,
  onPageChange
}) => {
  return (
    <TemplateList
      templates={templates}
      loading={loading}
      onEdit={onEdit}
      onDelete={onDelete}
      onUse={onUse}
      pagination={pagination}
      onPageChange={onPageChange}
    />
  );
};

export default TemplateTabContent;